/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_SubtitleInputs */



/**
* | output |
* | --- |
* | "Configure automatic user provisioning with your identity provider" |
*
* @param {Scim_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_subtitle = /** @type {((inputs?: Scim_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren Sie die automatische Benutzerbereitstellung mit Ihrem Identitätsanbieter")
	return /** @type {LocalizedString} */ ("Configure automatic user provisioning with your identity provider")
});